import { useState } from "react";
import clsx from "clsx";
import translate from "../locales";
import { DISTRICTSBREED } from "../data/data";
import { BudgetIcon, ChevronDownIcon, LocationIcon, TrashIcon } from "./icons";
import ConfirmDialog from "./confirm_dialog";

function formatBudget(budget) {
  return new Intl.NumberFormat("nl-BE", {
    maximumFractionDigits: 0,
  }).format(budget);
}

function formatPostcode(postcode) {
  return postcode === DISTRICTSBREED
    ? translate("results.districtsbreed")
    : postcode;
}

export default function OverviewCard({ project, onRemove }) {
  const [expanded, setExpanded] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  return (
    <article className="overview-card">
      <div className="overview-card__media">
        <img
          className="overview-card__image"
          src={project.image}
          alt=""
          draggable={false}
        />
        <span className="card__pill card__pill--category">
          {project.category}
        </span>
        <div className="card__pill-row">
          <span className="card__pill">
            <BudgetIcon className="card__pill-icon" />
            {formatBudget(project.budget)}
          </span>
          <span className="card__pill">
            <LocationIcon className="card__pill-icon" />
            {formatPostcode(project.postcode)}
          </span>
        </div>
      </div>
      <div className="overview-card__body">
        <h2 className="overview-card__title">{project.title}</h2>
        <div className="overview-card__actions">
          <button
            type="button"
            className={clsx(
              "overview-card__toggle",
              expanded && "overview-card__toggle--expanded",
            )}
            aria-expanded={expanded}
            onClick={() => setExpanded((v) => !v)}
          >
            {translate("results.more_info")}
            <ChevronDownIcon className="overview-card__chevron" />
          </button>
          <button
            type="button"
            className="overview-card__remove"
            aria-label={translate("results.remove")}
            onClick={() => setConfirmOpen(true)}
          >
            <TrashIcon className="overview-card__remove-icon" />
          </button>
        </div>
        {expanded && (
          <p className="overview-card__description">{project.description}</p>
        )}
      </div>
      <ConfirmDialog
        open={confirmOpen}
        title={translate("results.confirm_remove.title")}
        detail={`‘${project.title}’`}
        confirmLabel={translate("results.confirm_remove.confirm")}
        cancelLabel={translate("results.confirm_remove.cancel")}
        onConfirm={() => {
          setConfirmOpen(false);
          onRemove(project.id);
        }}
        onCancel={() => setConfirmOpen(false)}
      />
    </article>
  );
}
